import { useProposalCopyingForRecalTracked } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import ProposalCopyingForRecalItemRightPanel from "./ProposalCopyingForRecalItemRightPanel";
import ProposalCopyingForRecalTablePanel from "./Table/ProposalCopyingForRecalTablePanel";

const ProposalCopyingForRecalRightPanel = () => {
    const [proposalCopyingForRecalState] = useProposalCopyingForRecalTracked();
    const { isShowTariffItemPanel, isShowCopyToCompanyPanel, isShowEditPanel } = proposalCopyingForRecalState;

    return <>
        <div className={`main-comp-wrapper${(isShowTariffItemPanel || isShowCopyToCompanyPanel || isShowEditPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowTariffItemPanel ? ((isShowCopyToCompanyPanel || isShowEditPanel) ? "0%" : "25%") : "100%"}
                rightSectionWidth={isShowTariffItemPanel ? ((isShowCopyToCompanyPanel || isShowEditPanel) ? "100%" : "75%") : "0%"}
                leftChildren={<ProposalCopyingForRecalTablePanel />}
                rightChildren={<ProposalCopyingForRecalItemRightPanel />}
            />
        </div>
    </>
}

export default ProposalCopyingForRecalRightPanel;
